import React from "react";
import { useSelector } from "react-redux";

import FormNotesView from "components/FormNotesView";
import {API_PROPOSAL, COLUMN_HEADER_KEYS} from "globals/constants";
import { useFormAccesses} from "hooks";
import { getProposal } from "store/actions/proposal";
import { proposalSelectors } from "store/selectors";


const ProposalNotesView = () => {
	const proposal = useSelector(proposalSelectors.proposal);
	const formAccesses = useFormAccesses(COLUMN_HEADER_KEYS.PROPOSAL, proposal.proposalId);

	const formInstance = {
		instance: proposal,
		instanceId: proposal.proposalId,
		endpoint: API_PROPOSAL,
		type: COLUMN_HEADER_KEYS.PROPOSAL
	};

	return (
		<FormNotesView
			formInstance = { formInstance }
			canAddNotes = { formAccesses.addContent }
			canEditNotes = { formAccesses.updateContent }
			refreshForm = { getProposal }
		/>
	);
};

export default ProposalNotesView;
